<template>
  <div class="loading-container">
    <q-spinner color="primary" size="25px" />
    <div class="text-primary q-ml-md">{{ message }}</div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'LoadingOverlay',
  props: {
    message: {
      type: String,
      default: 'Loading data...'
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
